export default __webpack_public_path__ + "static/media/chevron-down-circle-fill.98a078b5.svg";